import React from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../redux/root-action';
import styled from 'styled-components';

const StyledContainer = styled.div<any>`
  font-family: "Nimbus Sans Novus Regular";
  font-size: 20px;
  line-height: 1.38;
  color: #3b4b59;
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media only screen and (max-width: 640px) {
    font-size: 16px;
  }
`;

class ReactModalContent extends React.Component<any> {
  props: any;
  render(): any {
    const { children } = this.props;
    return (
        <StyledContainer>
          {children}
        </StyledContainer>
    );
  }
}
export default connect(null, {
  closeModal: modalActions.closeModal,
})(ReactModalContent);
